<template>
  <div>
    <v-card-text class="select_customer">
      <v-row
        class="select_customer mt-1"
        @click="setShowCheckout(false)"
      >
        <v-col cols="2">
          <v-avatar size="56">
            <img
              width="80"
              src="@/assets/images/pages/default_room.png"
              alt=""
            >
          </v-avatar>
        </v-col>
        <v-col>
          <v-row no-gutters>
            <v-col
              style="color: black;"
              cols="8"
            >
              <h2><b style="color: black;">{{ getRoom.description }}</b></h2>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>{{ getRoom.category.description }}</v-col>
          </v-row>
        </v-col>
        <!-- <v-col class="text-right">
                <span style="font-size:16px">{{ getAccommodationValue.days }}x</span> <span class="text_total">R$ {{ formatMoney(getAccommodationValue.tariff) }}</span>
            </v-col> -->
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-row
      v-if="ifResponsible"
      class="px-4 py-2 align-center select-all-row"
      no-gutters
    >
      <v-col
        cols="auto"
        class="d-flex align-center mr-6"
      >
        <v-checkbox
          class="ma-0 pa-0"
          dense
          hide-details
          color="primary"
          :input-value="allDailySelected"
          :indeterminate="!allDailySelected && someDailySelected"
          @change="toggleSelectAll('daily', $event)"
        />
        <span class="select-all-label">Selecionar todas as diárias</span>
      </v-col>
      <v-col
        cols="auto"
        class="d-flex align-center"
      >
        <v-checkbox
          class="ma-0 pa-0"
          dense
          hide-details
          color="primary"
          :input-value="allProductSelected"
          :indeterminate="!allProductSelected && someProductSelected"
          @change="toggleSelectAll('product', $event)"
        />
        <span class="select-all-label">Selecionar todos os produtos</span>
      </v-col>
    </v-row>

    <v-virtual-scroll
      v-if="getItemsCheckout.length > 0"
      :items="getItemsCheckout"
      height="350"
      item-height="50"
    >
      <template v-slot:default="{ item }">
        <v-list-item :key="item.id">
          <v-list-item-content>
            <v-row
              class="item_checkout align-center"
              no-gutters
            >
              <v-col
                v-if="ifResponsible"
                cols="auto"
                class="d-flex align-center px-2"
              >
                <v-checkbox
                  v-if="visibleToResposible(item)"
                  v-model="item.checked"
                  class="ma-0 pa-0"
                  dense
                  hide-details
                  color="primary"
                  @click="addItemResponsible(item)"
                />
              </v-col>
              <v-col @click="editItemCheckout(item)">
                <b style="color:#16b1ff;font-size: small;">{{ item.description }}</b>
              </v-col>
              <v-col
                cols="3"
                class="text-right"
                @click="editItemCheckout(item)"
              >
                <span style="font-size:16px">{{ item.pivot.quantity }}x</span> <span class="text_total">R$ {{
                  formatMoney(item.sale_price) }}</span>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-virtual-scroll>
    <div
      v-else
      class="empty text-center pt-16"
    >
      <v-img
        width="50"
        class="mx-auto"
        src="@/assets/images/pages/empty_cart.png"
      ></v-img>
      Nenhum produto foi consumido
    </div>

    <v-divider></v-divider>
    <v-card-text>
      <v-row class="">
        <v-col class="text_total">
          Subtotal
        </v-col>
        <v-col
          color="black"
          class="text-right text_total "
        >
          R$ {{ formatMoney(getSubtotal) }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text_total">
          Impostos
        </v-col>
        <v-col class="text-right text_total">
          R$ {{ formatMoney(getTaxation) }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text_total">
          Desconto
        </v-col>
        <v-col class="text-right text_total">
          R$ {{ formatMoney(getDiscount.value) }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text_total">
          Adição
        </v-col>
        <v-col class="text-right text_total">
          R$ {{ formatMoney(getAdditional.value) }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="text_total">
          <b>Total</b>
        </v-col>
        <v-col class="text-right text_total">
          <b> R$ {{ formatMoney(getTotalToPay) }}</b>
        </v-col>
      </v-row>

      <v-divider
        v-if="(getpaymentMethods.length > 0 || getPaymentMethodsPartial.length > 0)"
        class="mb-4 mt-4"
      ></v-divider>
      <div v-if="loadingPaymentPartial">
        <v-row>
          <v-col class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row
          v-for="payment in getPaymentMethodsPartial"
          :key="payment.meyhod"
          no-gutters
        >
          <v-col class="text_total">
            <div style="white-space: nowrap;">
              <v-icon
                color="error"
                @click="showRemovePaymentPartial(payment)"
              >
                {{ icons.mdiTrashCanOutline }}
              </v-icon>
              {{ methodPayment(payment) }}
              <v-chip
                v-if="payment.partial"
                small
                color="warning"
              >
                Pag. parcial
              </v-chip>
            </div>
          </v-col>
          <v-col class="text-right text_total">
            R$ {{ formatMoney(payment.value) }}
          </v-col>
        </v-row>
        <v-row
          v-for="payment in getpaymentMethods"
          :key="payment.meyhod"
          no-gutters
        >
          <v-col class="text_total">
            <div style="white-space: nowrap;">
              <v-icon
                color="error"
                @click="removePayment(payment)"
              >
                {{ icons.mdiTrashCanOutline }}
              </v-icon>
              {{ methodPayment(payment) }}
              <v-chip
                v-if="payment.partial"
                small
                color="warning"
              >
                pagamento parcial
              </v-chip>
            </div>
          </v-col>
          <v-col class="text-right text_total">
            R$ {{ formatMoney(payment.value) }}
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-divider class=""></v-divider>
    <v-card class="d-flex align-end">
      <v-card-text>
        <v-row>
          <v-col class="pay text_total">
            <b>Pagar</b>
          </v-col>
          <v-col class="text-right pay text_total">
            <b>R$ {{ formatMoney(getToPay) }}</b>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pay text_total">
            <b :class="{ troco: (getChange > 0) }">Troco</b>
          </v-col>
          <v-col class="text-right pay text_total">
            <b :class="{ troco: (getChange > 0) }">R$ {{ formatMoney(getChange) }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  x-large
                  outlined
                  icon
                  tile
                  class=""
                  color="primary"
                  v-on="on"
                >
                  <v-icon> {{ icons.mdiDotsHorizontal }}</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="showDialogDiscount()">
                  <v-list-item-title>Desconto</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showDialogAdditional()">
                  <v-list-item-title>Adicionar Valor</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showNoteSale()">
                  <v-list-item-title>Nota</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showAttach()">
                  <v-list-item-title>Anexo</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showDialogObservations()">
                  <v-list-item-title>Observações</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="10">
            <!-- btn pagamento adiatado na reserva -->
            <v-btn
              v-if="getOriginPartialPayment == 'reserve'"
              color="warning"
              :loading="loadingPartial"
              :disabled="loadingPartial"
              x-large
              block
              @click="showDialogSelectCash()"
            >
              Pag. Adiantado R$ {{
                formatMoney(sumMethodPayment) }}
            </v-btn>
            <!-- pagamento adiantado no checkin -->
            <v-btn
              v-if="getOriginPartialPayment == 'accommodation'"
              color="warning"
              :loading="loadingPartial"
              :disabled="loadingPartial"
              x-large
              block
              @click="sendPartialPayment()"
            >
              Pagamento Parcial R$ {{
                formatMoney(sumMethodPayment) }}
            </v-btn>
            <!-- pagamento checkout -->
            <v-btn
              v-if="getOriginPartialPayment == 'checkout'"
              color="primary"
              :loading="loadingCheckout"
              :disabled="btnCheckout"
              x-large
              block
              @click="showDataNotaFiscal()"
            >
              Cobrar R$ {{ formatMoney(getToPay)
              }}
            </v-btn>
            <v-btn
              v-if="canTransferToGroupAccount"
              class="mt-2"
              color="secondary"
              :loading="loadingGroupTransfer"
              :disabled="loadingCheckout || loadingGroupTransfer"
              x-large
              block
              @click="openGroupTransfer()"
            >
              Enviar para conta master
            </v-btn>
            <group-transfer-dialog
              v-model="groupTransferDialog"
              :items="getItemsCheckout"
              :payments="groupTransferPayments"
              :new-payments="getpaymentMethods"
              :coverage-mode="groupCoverageMode"
              :loading="loadingGroupTransfer"
              @confirm="transferToGroupAccount"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DIALOG  NOTA  -->
    <v-dialog
      v-model="dialogNoteSale"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Nota de Checkout"
          @close="dialogNoteSale = false"
        />
        <v-card-text>
          <!-- <v-row class="mt-3">
                    <v-col>
                        <v-select outlined label="Pagamento recebido por"></v-select>
                    </v-col>
                </v-row> -->
          <v-row no-gutters>
            <v-col>
              <v-textarea
                id=""
                v-model="note"
                outlined
                name=""
                cols="30"
                rows="5"
                label="Notas sobre de checkout"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                @click="dialogNoteSale = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                x-large
                @click="saveNote()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG  DESCONTO -->
    <v-dialog
      v-model="dialogDiscount"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Desconto"
          @close="dialogDiscount = false"
        />
        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <vuetify-money
                v-model="discount.value"
                outlined
                label="Desconto"
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-textarea
                id=""
                v-model="discount.discount_obs"
                outlined
                name=""
                cols="30"
                rows="5"
                label="Observação"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                @click="dialogDiscount = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                x-large
                @click="saveDiscount()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG  ADDITIONAL  -->
    <v-dialog
      v-model="dialogAdditional"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Adicionar Valor"
          @close="dialogAdditional = false"
        />
        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <vuetify-money
                v-model="additional.value"
                outlined
                label="Valor"
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-textarea
                id=""
                v-model="additional.additional_obs"
                outlined
                name=""
                cols="30"
                rows="5"
                label="Observação"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                @click="dialogAdditional = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                x-large
                @click="saveAdditional()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG  AUTHORIZATION  -->
    <v-dialog
      v-model="dialogAuthorization"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Autorizar"
          @close="cancelAuthorization"
        />
        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <v-text-field
                v-model="admLogin.email"
                outlined
                label="Email"
                placeholder="Digite seu email"
                hide-details="auto"
                class="mb-6 mt-2"
                :error-messages="message_error_email"
                @keyup="validEmail"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                v-model="admLogin.password"
                outlined
                label="Senha"
                type="password"
                placeholder="Digite sua senha"
                hide-details="auto"
                :error-messages="message_error_email"
                @keyup="validPassword"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                :disabled="authorizationProcessing"
                @click="cancelAuthorization()"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                x-large
                :loading="authorizationProcessing"
                :disabled="authorizationProcessing"
                @click="requestAuthorization()"
              >
                Autorizar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG  ANEXO  -->
    <v-dialog
      v-model="dialogAttachPayment"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Anexo"
          @close="dialogAttachPayment = false"
        />
        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <v-file-input
                v-model="attach.attach"
                outlined
                rounded
                chips
                multiple
                label="Anexo"
              ></v-file-input>
            </v-col>
            <v-col
              v-if="getPaymentAttach"
              cols="4"
              class="text-center"
            >
              <v-btn
                :loading="loadingAttachDownload"
                rounded
                x-large
                color="secondary"
                @click="downloadAttach()"
              >
                <v-icon>
                  {{
                    icons.mdiDownload }}
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col>
              <v-textarea
                id=""
                v-model="attach.attach_obs"
                outlined
                name=""
                cols="30"
                rows="5"
                label="Observação"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                :disabled="loadingAttach"
                x-large
                @click="dialogAttachPayment = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingAttach"
                :disabled="loadingAttach"
                x-large
                @click="saveAttach()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG EDITAR ITEM DO CHECKOUT -->
    <dialog-edit-item-checkout
      v-model="dialogEditItemCheckout"
      :index="editItemCheckoutIndex"
    />

    <!-- DIALOG REMOVER PAGAMNETO PARCIAL -->
    <v-dialog
      v-model="dialogRemovePaymentPartial"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Remover Pag. Adiantado"
          @close="dialogRemovePaymentPartial = false"
        />
        <v-card-text>
          <v-row class="mt-3">
            <v-col>
              <v-textarea
                v-model="justifyRemovePaymentPartial"
                label="Justificativa"
                rows="2"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                class="mr-2"
                x-large
                @click="dialogRemovePaymentPartial = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="error"
                :loading="loadingRemovePaymentPartial"
                :disabled="loadingRemovePaymentPartial"
                x-large
                @click="removePaymentPartial()"
              >
                Remover
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG SELECIONAR CAIXA PARA PAGAMENTO ADIANTADO -->
    <v-dialog
      v-model="dialogSelectCash"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="CAIXA"
          @close="dialogSelectCash = false"
        />
        <v-card-title class="text-h5 text-center">
          <v-row no-gutters>
            <v-col>Qual caixa ficará associado !</v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <!-- <v-row>
          <v-col>
            <v-textarea v-model="justifyCancel" outlined label="Justificativa" rows="3"></v-textarea>
          </v-col>
        </v-row> -->
          <v-row>
            <v-col>
              <v-select
                v-model="partialReserveCashId"
                :loading="loadingOpenedCashs"
                :disabled="loadingOpenedCashs"
                outlined
                label="Caixa"
                :items="cashItems"
                item-value="id"
                item-text="text"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="loadingUserAdmin">
            <v-col class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="blue darken-1"
            text
            @click="dialogSelectCash = false"
          >
            fechar
          </v-btn>
          <v-btn
            large
            color="primary"
            :loading="loadingCancel"
            @click="sendReservePartialPayment()"
          >
            ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDataNotaFiscal"
      width="800"
    >
      <v-card>
        <BarTitleDialog
          title="dados para nota fiscal"
          @close="dialogDataNotaFiscal = false"
        />
        <v-card-text>
          <v-row no-gutters>
            <v-col class="col-4">
              <v-select
                v-model="typeOfPerson"
                label="Tipo de Pessoa"
                outlined
                :items="[{ value: 'PF', text: 'FÍSICA' }, { value: 'PJ', text: 'JURÍDICA' }]"
                @change="onTypeOfPersonChange"
              >
              </v-select>
            </v-col>
            <v-col class="mx-6">
              <v-switch
                v-model="noShow"
                color="primary"
                label="NO-SHOW"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              v-if="typeOfPerson == 'PF'"
              class="col-8"
            >
              <AutocompleteSearchGuest
                v-model="dataNotaFiscal"
                @change="test()"
              ></AutocompleteSearchGuest>
            </v-col>
            <v-col
              v-if="typeOfPerson == 'PJ'"
              class="col-8"
            >
              <AutocompleteSearchCompany
                v-model="dataNotaFiscal"
                @change="test()"
              ></AutocompleteSearchCompany>
            </v-col>

            <v-col v-if="typeOfPerson == 'PF'">
              <v-text-field
                v-model="dataNotaFiscal.cpf"
                v-mask="'###.###.###-##'"
                disabled
                class="ml-2"
                outlined
                label="CPF"
                :hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col v-if="typeOfPerson == 'PJ'">
              <v-text-field
                v-model="dataNotaFiscal.cpf_cnpj"
                v-mask="'##.###.###/####-##'"
                disabled
                class="ml-2"
                outlined
                label="CPF/CNPJ"
                :hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <v-text-field
                v-model="dataNotaFiscal.address"
                disabled
                outlined
                hide-details
                label="Endereço"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="3">
              <v-text-field
                v-model="dataNotaFiscal.number"
                disabled
                outlined
                hide-details
                label="Número"
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="dataNotaFiscal.complement"
                disabled
                outlined
                hide-details
                label="Complemento"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="12">
              <v-text-field
                v-model="dataNotaFiscal.neighborhood"
                disabled
                outlined
                hide-details
                label="Bairro"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col class="">
              <v-text-field
                v-model="dataNotaFiscal.zipcode"
                v-mask="'##.###-###'"
                disabled
                outlined
                hide-details
                label="CEP"
              ></v-text-field>
            </v-col>
            <v-col
              cols=""
              class="ml-2"
            >
              <v-text-field
                v-model="cityNotaFiscal"
                disabled
                outlined
                label="Cidade"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <v-col cols="">
              <v-text-field
                v-model="stateNotaFiscal"
                disabled
                outlined
                label="Estado"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              class="ml-2"
            >
              <v-text-field
                v-model="countryNotaFiscal"
                disabled
                outlined
                label="Pais"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-2"
          >
            <!-- <v-col cols="3">
              <v-text-field disabled v-mask="'(##)####-####'" v-model="dataNotaFiscal.home_phone" outlined hide-details
                label="Fone Res."></v-text-field>
            </v-col> -->
            <v-col class="">
              <v-text-field
                v-model="dataNotaFiscal.commercial_phone"
                v-mask="'(##)####-####'"
                disabled
                outlined
                hide-details
                label="Fone Com."
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="dataNotaFiscal.cell_phone"
                v-mask="'(##)#####-####'"
                disabled
                outlined
                hide-details
                label="Celular"
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-text-field
                v-model="dataNotaFiscal.email"
                disabled
                outlined
                hide-details
                label="Email"
              ></v-text-field>
            </v-col>
            <!-- <v-col class="ml-2">
              <v-text-field disabled v-mask="'(##)####-####'" v-model="dataNotaFiscal.fax_phone" outlined hide-details
                label="Fax"></v-text-field>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                color="primary"
                @click="confirmCheckout()"
              >
                ok
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogObservation"
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Observações"
          @close="dialogObservation = false"
        ></BarTitleDialog>
        <v-card-text>
          <v-data-table
            hide-default-footer
            :headers="headers_observation"
            :items="accommodation_observations"
            class="elevation-1"
            dense
            hide-default-header
          >
            <template v-slot:no-data>
              <NoDataTable>Nenhuma observação disponível</NoDataTable>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                text
                x-large
                class="mr-4"
                @click="dialogObservation = false"
              >
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,

  // mapState,
} from 'vuex'
import {
  mdiDotsHorizontal, mdiTrashCanOutline, mdiEyeOutline, mdiDownload,
} from '@mdi/js'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import DialogEditItemCheckout from './DialogEditItemCheckout.vue'
import GroupTransferDialog from './GroupTransferDialog.vue'
import AutocompleteSearchGuest from '@/components/AutocompleteSearchGuest'
import AutocompleteSearchCompany from '@/components/AutocompleteSearchCompany'

export default {
  components: {
    GroupTransferDialog,
    BarTitleDialog,
    DialogEditItemCheckout,
    AutocompleteSearchGuest,
    AutocompleteSearchCompany,
  },
  data: () => ({
    // dialodDataNotaFiscal
    dialogDataNotaFiscal: false,
    dataNotaFiscal: '', // { guest: '' },
    noShow: false,
    stateNotaFiscal: '',
    cityNotaFiscal: '',
    countryNotaFiscal: '',
    typeOfPerson: 'PF',

    // Observações
    accommodation_observations: [],
    dialogObservation: false,
    headers_observation: [
      {
        text: 'Observações',
        sortable: false,
        align: 'start',
        value: 'description',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],

    // Admin Status
    admRole: {},
    dialogAuthorization: false,
    pendingAuthorization: null,
    authorizationProcessing: false,
    message_error_email: '',
    message_error_password: '',

    // dialog seleciona caixa
    dialogSelectCash: false,
    partialReserveCashId: null,
    loadingOpenedCashs: false,
    cashItems: [],

    // dialog remover pagamento parcial
    itemRemovePaymentPartial: {},
    dialogRemovePaymentPartial: false,
    loadingRemovePaymentPartial: false,
    justifyRemovePaymentPartial: '',

    loadingUserAdmin: false,
    loadingCancel: false,
    loadingAttachDownload: false,
    loadingAttach: false,
    dialogAttachPayment: false,
    loadingPaymentPartial: false,
    loadingPartial: false,
    editItemCheckoutIndex: null,
    dialogEditItemCheckout: false,
    dialogNoteSale: false,
    dialogCancelSale: false,
    gratuity_active: false,
    loadingCheckout: false,
    loadingGroupTransfer: false,
    groupTransferDialog: false,
    groupTransferPayments: [],
    groupCoverageMode: 'lodging',
    groupTransferAccount: null,
    dialogDiscount: false,
    dialogAdditional: false,
    discount: {
      discount_obs: '',
      value: '',
    },
    additional: {
      additional_obs: '',
      value: '',
    },
    admLogin: {
      email: '',
      password: '',
    },
    attach: {
      attach: null,
      attach_obs: '',
    },
    icons: {
      mdiDotsHorizontal,
      mdiTrashCanOutline,
      mdiEyeOutline,
      mdiDownload,
    },
  }),
  created() {
    this.loadPartialPayment()
    this.cashsOpen().then(response => {
      this.cashItems = response.data
    })
    this.loadCurrentRole()
  },
  computed: {
    ...mapGetters('checkout', [
      'getTaxation',
      'getAccommodationValue',
      'getAdditional',
      'getDiscount',
      'getNote',
      'remainingValue',
      'getChange',
      'getRoom',
      'getItemsCheckout',
      'getStage',
      'getpaymentMethods',
      'getSubtotal',
      'getTotalToPay',
      'getSelectecResposible',
      'activeBtnCheckout',
      'getOriginPartialPayment',
      'getPaymentMethodsPartial',
      'getToPay',
      'getPaymentAttach',
    ]),

    sumMethodPayment() {
      return this.getpaymentMethods.reduce((acc, method) => acc + parseFloat(method.value), 0)
    },

    btnCheckout() {
      if (this.loadingCheckout) {
        return true
      }

      return !(this.activeBtnCheckout <= 0)
    },
    groupReserveId() {
      const accommodation = this.getRoom?.current_accommodation

      return accommodation?.reserve?.group_reserve_id || this.getRoom?.current_reserve?.group_reserve_id || null
    },
    canTransferToGroupAccount() {
      return this.getOriginPartialPayment === 'checkout' && !!this.groupReserveId
    },

    note: {
      get() {
        return this.getNote
      },
      set(val) {
        this.setNote(val)
      },
    },

    itemsCheckout() {
      return this.checkout
    },

    emptyCheckout() {
      if (this.checkout.length > 0) {
        return false
      }

      return true
    },

    ifResponsible() {
      if (Object.keys(this.getSelectecResposible).length > 0) {
        return true
      }

      return false
    },
    dailyItems() {
      return this.getItemsCheckout.filter(item => item.origin === 'accommodation' || item.origin === 'accommodation_extra_item')
    },
    productItems() {
      const productOrigins = ['product', 'service', 'extra_tarif']

      return this.getItemsCheckout.filter(item => productOrigins.includes(item.origin))
    },
    selectableDailyItems() {
      return this.dailyItems.filter(item => this.visibleToResposible(item))
    },
    selectableProductItems() {
      return this.productItems.filter(item => this.visibleToResposible(item))
    },
    allDailySelected() {
      const items = this.selectableDailyItems

      return items.length > 0 && items.every(item => item.checked)
    },
    someDailySelected() {
      const items = this.selectableDailyItems

      return items.some(item => item.checked) && !this.allDailySelected
    },
    allProductSelected() {
      const items = this.selectableProductItems

      return items.length > 0 && items.every(item => item.checked)
    },
    someProductSelected() {
      const items = this.selectableProductItems

      return items.some(item => item.checked) && !this.allProductSelected
    },
  },
  methods: {
    ...mapMutations('checkout', [
      'clearCheckout',
      'setAdditional',
      'setDiscount',
      'setStage',
      'removePaymentMethod',
      'setNote',
      'setShowCheckout',
      'addItemResponsible',
      'addPaymentMethod',
      'setPaymentMethodsPartial',
      'setRoom',
      'setDataNotaFiscal',
    ]),
    ...mapActions('checkout', [
      'saveUnpaid',
      'storeSale',
      'exportPdfCheckout',
      'storePartialPayment',
      'storeResevePartialPayment',
      'getPartialPayment',
      'getResevePartialPayment',
      'storeAttach',
      'getDownloadAttach',
      'destroyPaymentPartial',
      'getUser',
      'cashsOpen',
    ]),
    ...mapActions('select', ['loadAdmRole']),
    ...mapActions('select', ['get_states', 'get_cities', 'get_countries']),
    ...mapActions('authorization', { runAuthorization: 'run' }),
    ...mapActions('busy', ['getAccommodationObservations']),
    ...mapActions('company', ['getCompanyCredit']),
    ...mapActions('reserve', ['getGroupAccount']),
    test() {
      this.cityNotaFiscal = this.dataNotaFiscal?.city?.name || ''
      this.stateNotaFiscal = this.dataNotaFiscal?.state?.name || ''
      this.countryNotaFiscal = this.dataNotaFiscal?.country?.name || ''
    },
    async onTypeOfPersonChange() {
      await this.prefillDefaultFiscalData()
    },
    async prefillDefaultFiscalData() {
      const responsible = this.getDefaultResponsibleByType(this.typeOfPerson)
      if (!responsible) {
        this.dataNotaFiscal = ''
        this.cityNotaFiscal = ''
        this.stateNotaFiscal = ''
        this.countryNotaFiscal = ''

        return
      }

      const {
        is_custom, origin, cleaned, ...responsibleData
      } = responsible
      this.applyNotaFiscalFromResponsible(responsibleData, this.typeOfPerson)
      await this.enrichNotaFiscalLocationFromIds()
    },
    async enrichNotaFiscalLocationFromIds() {
      if (!this.dataNotaFiscal || typeof this.dataNotaFiscal !== 'object') {
        return
      }

      const nota = this.dataNotaFiscal
      let stateName = this.stateNotaFiscal || ''
      let cityName = this.cityNotaFiscal || ''
      let countryName = this.countryNotaFiscal || ''

      if (!stateName && nota.state_id) {
        const response = await this.get_states()
        const states = Array.isArray(response?.data) ? response.data : []
        const state = states.find(item => String(item.id) === String(nota.state_id))
        if (state) {
          stateName = state.name || ''
          nota.state = { id: state.id, name: state.name }
          nota.state_id = state.id

          if (!cityName && nota.city_id && state.code != null) {
            const cityResponse = await this.get_cities(state.code)
            const cities = Array.isArray(cityResponse?.data) ? cityResponse.data : []
            const city = cities.find(item => String(item.id) === String(nota.city_id))
            if (city) {
              cityName = city.name || ''
              nota.city = { id: city.id, name: city.name }
              nota.city_id = city.id
            }
          }
        }
      }

      if (!countryName && nota.country_id) {
        const response = await this.get_countries()
        const countries = Array.isArray(response?.data) ? response.data : []
        const country = countries.find(item => String(item.id) === String(nota.country_id))
        if (country) {
          countryName = country.name || ''
          nota.country = { id: country.id, name: country.name }
          nota.country_id = country.id
        }
      }

      this.cityNotaFiscal = cityName
      this.stateNotaFiscal = stateName
      this.countryNotaFiscal = countryName
      this.setDataNotaFiscal(nota)
    },
    getDefaultResponsibleByType(typeOfPerson) {
      const accommodation = this.getRoom?.current_accommodation
      if (!accommodation) {
        return null
      }

      if (typeOfPerson === 'PJ') {
        if (!accommodation.company) {
          return null
        }

        return this.resolveResponsibleData({
          ...accommodation.company,
          origin: 'company',
        })
      }

      const guests = Array.isArray(accommodation.guest) ? accommodation.guest : []
      if (guests.length === 0) {
        return null
      }

      const principalGuest = guests.find(guest => this.isPrincipalGuest(guest)) || guests[0]

      return this.resolveResponsibleData({
        ...principalGuest,
        origin: 'guest',
      })
    },
    isPrincipalGuest(guest) {
      if (!guest) {
        return false
      }

      const flagKeys = ['is_principal', 'principal', 'main_guest', 'guest_principal', 'is_main', 'holder', 'titular']
      const isTrue = value => value === true || value === 1 || value === '1' || value === 'true' || value === 'sim'

      return flagKeys.some(key => isTrue(guest[key]) || isTrue(guest?.pivot?.[key]))
    },
    loadPartialPayment() {
      // se origem do pagamanto e checkout (pagamento parcial)
      if (this.getOriginPartialPayment == 'reserve') {
        // se origem for reserva carrega  pagamento adiantato
        this.getPartialPaymentReserve()
      } else {
        this.getPartialPaymentCheckout()
      }
    },
    downloadAttach() {
      this.loadingAttachDownload = true
      const attach_id = this.getRoom.current_accommodation.payment_attachment.id

      this.getDownloadAttach(attach_id)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'attach.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
        })
        .finally(() => {
          this.loadingAttachDownload = false
        })
    },
    getPartialPaymentCheckout() {
      // se for pagamneto parcial carrega os pagamentos registrado
      //  if (this.getFlagPartialPayment) {
      this.setPaymentMethodsPartial([])
      this.loadingPaymentPartial = true
      this.loadingPartial = true // btn
      this.getPartialPayment()
        .then(response => {
          const payments = response.data
          const methodPayments = []
          payments.forEach(payment => {
            let responsibleOrigin = null
            let responsibleId = null
            if (payment.company_id) {
              responsibleOrigin = 'company'
              responsibleId = payment.company_id
            } else if (payment.guest_id) {
              responsibleOrigin = 'guest'
              responsibleId = payment.guest_id
            }

            if (!responsibleOrigin && payment.method === 'invoice') {
              const companyId = this.getRoom?.current_accommodation?.company?.id
              if (companyId) {
                responsibleOrigin = 'company'
                responsibleId = companyId
              }
            }

            const data = {
              payment_item_id: payment.id,
              id: responsibleId || payment.pix_id,
              pix_id: payment.pix_id,
              method: payment.method,
              value: payment.value,
              partial: true,
              origin: responsibleOrigin,
            }
            methodPayments.push(data)

            // this.addPaymentMethod(data)
          })
          this.setPaymentMethodsPartial(methodPayments)
        })
        .finally(() => {
          this.loadingPaymentPartial = false
          this.loadingPartial = false // btn
        })

      // }
    },
    getPartialPaymentReserve() {
      // se for pagamneto parcial carrega os pagamentos registrado
      //  if (this.getFlagPartialPayment) {
      this.setPaymentMethodsPartial([])
      this.loadingPaymentPartial = true
      this.loadingPartial = true // btn
      this.getResevePartialPayment()
        .then(response => {
          const payments = response.data
          const methodPayments = []
          payments.forEach(payment => {
            let responsibleOrigin = null
            let responsibleId = null
            if (payment.company_id) {
              responsibleOrigin = 'company'
              responsibleId = payment.company_id
            } else if (payment.guest_id) {
              responsibleOrigin = 'guest'
              responsibleId = payment.guest_id
            }

            if (!responsibleOrigin && payment.method === 'invoice') {
              const companyId = this.getRoom?.current_accommodation?.company?.id
              if (companyId) {
                responsibleOrigin = 'company'
                responsibleId = companyId
              }
            }

            const data = {
              payment_item_id: payment.id,
              id: responsibleId || payment.pix_id,
              pix_id: payment.pix_id,
              method: payment.method,
              value: payment.value,
              partial: true,
              origin: responsibleOrigin,
            }
            methodPayments.push(data)

            // this.addPaymentMethod(data)
          })
          this.setPaymentMethodsPartial(methodPayments)
        })
        .finally(() => {
          this.loadingPaymentPartial = false
          this.loadingPartial = false // btn
        })

      // }
    },

    // ESCOLHER O CAIXA Q VAI FICA ASSOCIADO
    showDialogSelectCash() {
      if (this.getOriginPartialPayment == 'reserve') {
        this.dialogSelectCash = true
      } else {
        this.getUser().then(response => {
          if (response.data.role.name == 'Admin') {
            this.dialogSelectCash = true
          } else {
            this.sendReservePartialPayment()
          }
        })
      }
    },
    sendReservePartialPayment() {
      this.loadingPartial = true
      const data = { cash_id: this.partialReserveCashId }
      this.storeResevePartialPayment(data)
        .then(() => {
          this.$toast.success('Pagamento realizado com sucesso !')
          this.$router.push('/reserve')
        })
        .finally(() => {
          this.loadingPartial = false
        })
    },

    sendPartialPayment() {
      this.loadingPartial = true
      this.storePartialPayment()
        .then(() => {
          this.$toast.success('Pagamento realizado com sucesso !')
          this.$router.push('/manager_room')
        })
        .finally(() => {
          this.loadingPartial = false
        })
    },
    visibleToResposible(item) {
      if (item.responsible) {
        if (item.responsible.id == this.getSelectecResposible.id) {
          return true
        }

        return false
      }

      return true
    },
    saveAttach() {
      this.loadingAttach = true
      this.storeAttach(this.attach)
        .then(response => {
          this.$toast.success('Arquivo anexado com sucesso !')
          this.attach.attach = null
          this.attach.attach_obs = ''
          this.dialogAttachPayment = false
          const room = this.getRoom
          room.current_accommodation.payment_attachment = response.data
          this.setRoom(room)
        })
        .finally(() => {
          this.loadingAttach = false
        })
    },
    methodPayment(payment) {
      switch (payment.method) {
        case 'debit_card':
          return 'Cartão Débito'
        case 'credit_card':
          return 'Cartão Crédito'
        case 'money':
          return 'Dinheiro'
        case 'other':
          return 'Outros'
        case 'pix':
          return 'Pix'
        case 'invoice':
          return 'Faturado'
        case 'b2b':
          return 'B2B'
        case 'chess_engine':
          return 'Chess Engine'
      }
    },
    showDialogDiscount() {
      this.dialogDiscount = true
    },
    showDialogAdditional() {
      this.dialogAdditional = true
    },

    // nextStage() {
    //     switch (this.getStage) {
    //         case 'new_sale':
    //             this.setStage('gratuity')
    //             break
    //         case 'gratuity':
    //             this.setStage('payment')
    //             break
    //         case 'payment':
    //             this.setStage('new_sale')
    //             break
    //     }
    // },
    saveDiscount() {
      this.setDiscount(this.discount)
      this.dialogDiscount = false
    },
    saveAdditional() {
      this.setAdditional(this.additional)
      this.dialogAdditional = false
    },
    editItemCheckout(item) {
      this.editItemCheckoutIndex = this.getItemsCheckout.indexOf(item)
      this.dialogEditItemCheckout = true
    },
    showRemovePaymentPartial(payment) {
      this.itemRemovePaymentPartial = payment
      this.dialogRemovePaymentPartial = true
    },
    removePaymentPartial() {
      // Validação de justificativa
      if (!this.justifyRemovePaymentPartial?.trim()) {
        this.$toast.error('Justificativa obrigatória')

        return
      }

      const payload = {
        justify: this.justifyRemovePaymentPartial,
        payment_item_id: this.itemRemovePaymentPartial.payment_item_id,
      }

      // Executa diretamente (sem verificação prévia)
      this.performRemovePaymentPartial(payload)
    },
    performRemovePaymentPartial(payload, token = null) {
      this.loadingRemovePaymentPartial = true

      let request
      if (token) {
        // Segunda tentativa: com token do Admin (após autorização)
        request = this.$http.post(`manager_room/remove_partial_payment/${payload.payment_item_id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        // Primeira tentativa: com token do usuário logado
        request = this.destroyPaymentPartial(payload)
      }

      return request
        .then(response => {
          this.dialogRemovePaymentPartial = false
          this.loadPartialPayment()
          this.$toast.success('Pagamento adiantado removido')
          this.justifyRemovePaymentPartial = ''
          this.loadingRemovePaymentPartial = false
        })
        .catch(error => {
          // Detecta 403 e solicita autorização
          if (!token && error?.response?.status === 403) {
            // Mantém loading ativo enquanto espera autorização
            this.queueAuthorization('remove_payment_partial', payload)

            return Promise.resolve() // Não mostra erro, abre dialog
          }

          // Outros erros - para o loading
          this.loadingRemovePaymentPartial = false
          this.$toast.error(error?.response?.data?.message || 'Erro ao remover pagamento')

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadCurrentRole()
        })
    },
    removePayment(payment) {
      this.removePaymentMethod(payment)
    },
    showNoteSale() {
      this.dialogNoteSale = true
    },
    showAttach() {
      this.dialogAttachPayment = true
    },
    saveNote() {
      this.dialogNoteSale = false
    },

    // showCancelSale() {
    //     this.dialogCancelSale = true
    // },
    // confirmCancelSale() {
    //     this.cancelSale()
    //     this.dialogCancelSale = false
    // },
    // sendSaveUnpaid() {
    //     this.saveUnpaid().then((response) => {

    //     }).finally(() => {

    //     })

    // },
    // dialog pra dados da nota fiscal
    async showDataNotaFiscal() {
      if (this.shouldAutoCheckoutCorporateAccommodationNoConsumption()) {
        const autoFinished = this.tryAutoCheckoutCorporateAccommodationNoConsumption()
        if (autoFinished) {
          return
        }
      }

      if (this.shouldForceSeparatePaymentForCorporateAccommodation()) {
        const prepared = await this.prepareCorporateAccommodationSeparatePayment()
        if (!prepared) {
          return
        }

        this.setStage('separate_payment')
        this.$toast.info('Hospedagem faturada na empresa. Defina o pagamento do consumo em Pagamento Separado.')

        return
      }

      // Se estiver em modo de pagamento separado, os itens já foram atribuídos aos responsáveis
      // então não precisa abrir o modal de confirmação, vai direto para o checkout
      if (this.getStage === 'separate_payment') {
        const canContinue = await this.ensureConsumptionResponsibleSelection()
        if (!canContinue) {
          return
        }

        const responsibles = this.collectResponsiblesForInvoice()
        const validationIssues = responsibles
          .map(responsible => this.validateResponsibleForInvoice(responsible))
          .filter(issue => issue !== null)

        if (validationIssues.length > 0) {
          const firstIssue = validationIssues[0]
          this.typeOfPerson = firstIssue.type

          const issuesHtml = validationIssues
            .map(issue => `<p><strong>${issue.name}</strong>: ${issue.message}</p>`)
            .join('')

          this.$swal({
            confirmButtonColor: '#16b1ff',
            cancelButtonColor: '#d33',
            showCancelButton: true,
            confirmButtonText: 'Ir para Cadastros',
            cancelButtonText: 'Cancelar',
            position: 'center',
            html: issuesHtml,
            icon: 'warning',
            title: 'Dados Incompletos',
          }).then(result => {
            if (result.isConfirmed) {
              if (firstIssue.type === 'PF') {
                this.$router.push('/guest')
              } else {
                this.$router.push('/company')
              }
            }
          })

          return
        }

        // Pega o primeiro método de pagamento para definir o responsável principal
        const firstPaymentMethod = this.getpaymentMethods.find(payment => payment.origin && payment.id)

        if (firstPaymentMethod) {
          const paymentOrigin = firstPaymentMethod.origin
          const paymentId = firstPaymentMethod.id

          // Busca o responsável correto nos itens do checkout ou na acomodação
          let responsible = this.resolveResponsibleData({
            origin: paymentOrigin,
            id: paymentId,
          })
          if (!responsible) {
            if (paymentOrigin === 'guest') {
              const itemWithGuest = this.getItemsCheckout.find(
                item => item.responsible && item.responsible.origin === 'guest' && item.responsible.id === paymentId,
              )
              responsible = this.resolveResponsibleData(itemWithGuest ? itemWithGuest.responsible : null)
            } else if (paymentOrigin === 'company') {
              const itemWithCompany = this.getItemsCheckout.find(
                item => item.responsible && item.responsible.origin === 'company' && item.responsible.id === paymentId,
              )
              responsible = this.resolveResponsibleData(itemWithCompany ? itemWithCompany.responsible : null)
            }
          }

          if (responsible) {
            // Define o tipo de pessoa baseado na origem
            const typeOfPerson = responsible.origin === 'guest' ? 'PF' : 'PJ'

            // Remove propriedades que não devem ser enviadas ao backend
            const { is_custom, origin, ...responsibleData } = responsible

            this.applyNotaFiscalFromResponsible(responsibleData, typeOfPerson)
          }
        }

        this.sendSale()
      } else {
        this.prefillFiscalDataForCorporateBilling()
        await this.prefillDefaultFiscalData()
        this.dialogDataNotaFiscal = true
      }
    },
    getBillingContext() {
      const accommodation = this.getRoom?.current_accommodation
      if (!accommodation) {
        return {
          reserve: null,
          billingEnabled: false,
          billingScope: null,
        }
      }

      const reserve = accommodation.reserve || this.getRoom?.current_reserve || accommodation
      const billingEnabled = reserve && (reserve.billing_checkout_enabled === true
        || reserve.billing_checkout_enabled === 1
        || reserve.billing_checkout_enabled === '1')

      return {
        reserve,
        billingEnabled,
        billingScope: reserve?.billing_checkout_scope || null,
      }
    },
    isConsumptionItem(item) {
      return item.origin === 'product' || item.origin === 'service'
    },
    isAccommodationItem(item) {
      return item.origin === 'accommodation' || item.origin === 'extra_tarif' || item.origin === 'accommodation_extra_item'
    },
    shouldForceSeparatePaymentForCorporateAccommodation() {
      const { billingEnabled, billingScope } = this.getBillingContext()
      if (!billingEnabled || billingScope !== 'accommodation') {
        return false
      }

      if (this.getStage === 'separate_payment') {
        return false
      }

      return this.getItemsCheckout.some(item => this.isConsumptionItem(item))
    },
    shouldAutoCheckoutCorporateAccommodationNoConsumption() {
      const { billingEnabled, billingScope } = this.getBillingContext()
      if (!billingEnabled || billingScope !== 'accommodation') {
        return false
      }

      if (this.getStage === 'separate_payment') {
        return false
      }

      return !this.getItemsCheckout.some(item => this.isConsumptionItem(item))
    },
    isWithIssEnabled() {
      const withIss = this.getRoom?.current_accommodation?.with_iss

      return withIss === true || withIss === 1 || withIss === '1' || withIss === 'yes' || withIss === 'true' || withIss === 'sim'
    },
    calculateAccommodationInvoiceValueForCompany(companyId) {
      const withIss = this.isWithIssEnabled()
      const issRate = this.$store.getters['config/getIssRate'] || 0.03

      return this.getItemsCheckout.reduce((acc, item) => {
        if (!this.isAccommodationItem(item)) {
          return acc
        }

        if (!item.responsible || item.responsible.origin !== 'company' || item.responsible.id !== companyId) {
          return acc
        }

        const quantity = Number(item?.pivot?.quantity ?? 1)
        const salePrice = Number(item.sale_price || 0)
        let total = salePrice * quantity

        if (item.origin === 'accommodation' && withIss) {
          total += issRate * salePrice * quantity
        }

        return acc + total
      }, 0)
    },
    ensureCompanyInvoicePayment(company) {
      if (!company || !company.id) {
        return
      }

      const invoiceValue = this.calculateAccommodationInvoiceValueForCompany(company.id)
      if (invoiceValue <= 0) {
        return
      }

      const invoicePayment = this.getpaymentMethods.find(payment => payment.method === 'invoice')
      if (invoicePayment) {
        invoicePayment.origin = 'company'
        invoicePayment.id = company.id
        invoicePayment.billing_scope = 'accommodation'
        invoicePayment.value = invoiceValue

        return
      }

      this.addPaymentMethod({
        method: 'invoice',
        value: invoiceValue,
        origin: 'company',
        id: company.id,
        billing_scope: 'accommodation',
        auto_billing: true,
      })
    },
    async prepareCorporateAccommodationSeparatePayment() {
      const accommodation = this.getRoom?.current_accommodation
      const company = accommodation?.company
      if (!company) {
        this.$toast.error('Empresa não encontrada para separar o faturamento da hospedagem.')

        return false
      }

      const canAssignConsumption = await this.ensureConsumptionResponsibleSelection()
      if (!canAssignConsumption) {
        return false
      }

      this.ensureCompanyInvoicePayment(company)

      return true
    },
    tryAutoCheckoutCorporateAccommodationNoConsumption() {
      const accommodation = this.getRoom?.current_accommodation
      const company = accommodation?.company
      if (!company) {
        return false
      }

      const companyResponsible = {
        ...company,
        origin: 'company',
      }

      const validationIssue = this.validateResponsibleForInvoice(companyResponsible)
      if (validationIssue) {
        this.prefillFiscalDataForCorporateBilling()

        return false
      }

      this.ensureCompanyInvoicePayment(company)
      this.applyNotaFiscalFromResponsible(company, 'PJ')
      this.sendSale()

      return true
    },
    prefillFiscalDataForCorporateBilling() {
      const { billingEnabled, billingScope } = this.getBillingContext()
      if (!billingEnabled) {
        return
      }

      const accommodation = this.getRoom?.current_accommodation
      const company = accommodation?.company
      if (!company) {
        return
      }

      const hasConsumption = this.getItemsCheckout.some(item => this.isConsumptionItem(item))
      const shouldPrefillCompany = billingScope === 'total' || (billingScope === 'accommodation' && !hasConsumption)

      if (shouldPrefillCompany) {
        this.applyNotaFiscalFromResponsible(company, 'PJ')
      }
    },
    async ensureConsumptionResponsibleSelection() {
      const { billingEnabled, billingScope } = this.getBillingContext()
      if (!billingEnabled || billingScope !== 'accommodation') {
        return true
      }

      const accommodation = this.getRoom?.current_accommodation
      const company = accommodation?.company
      const guests = Array.isArray(accommodation?.guest) ? accommodation.guest : []
      const consumptionItems = this.getItemsCheckout.filter(item => this.isConsumptionItem(item))
      if (!company || consumptionItems.length === 0) {
        return true
      }

      // Garante hospedagem faturada na empresa
      this.getItemsCheckout.forEach(item => {
        if (this.isAccommodationItem(item)) {
          item.responsible = {
            ...company,
            origin: 'company',
          }
        }
      })

      const hasGuestAssignedInConsumption = consumptionItems.some(item => item.responsible && item.responsible.origin === 'guest')
      if (hasGuestAssignedInConsumption) {
        return true
      }

      if (guests.length === 0) {
        this.$toast.error('Não há hóspede disponível para vincular o consumo.')

        return false
      }

      let selectedGuest = guests[0]
      if (guests.length > 1) {
        const inputOptions = guests.reduce((acc, guest) => {
          acc[String(guest.id)] = guest.name

          return acc
        }, {})

        const result = await this.$swal({
          title: 'Nota do consumo',
          text: 'Selecione para quem será emitida a nota do consumo.',
          input: 'select',
          inputOptions,
          inputPlaceholder: 'Selecione um hóspede',
          showCancelButton: true,
          confirmButtonColor: '#16b1ff',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          inputValidator: value => {
            if (!value) {
              return 'Selecione um hóspede'
            }

            return null
          },
        })

        if (!result.isConfirmed) {
          return false
        }

        selectedGuest = guests.find(guest => String(guest.id) === String(result.value)) || guests[0]
      }

      consumptionItems.forEach(item => {
        item.responsible = {
          ...selectedGuest,
          origin: 'guest',
        }
      })

      this.$toast.info(`Consumo vinculado para ${selectedGuest.name}.`)

      return true
    },
    confirmCheckout() {
      if (this.dataNotaFiscal == '' || this.dataNotaFiscal == null) {
        this.$toast.error('É obrigatório ter uma pessoa Física ou Jurídica para gerar Nota Fiscal')

        return false
      }

      // Validação dos dados necessários para emissão de notas fiscais
      const validationError = this.validateDataForInvoice()
      if (validationError) {
        this.$swal({
          confirmButtonColor: '#16b1ff',
          cancelButtonColor: '#d33',
          showCancelButton: true,
          confirmButtonText: 'Ir para Cadastros',
          cancelButtonText: 'Cancelar',
          position: 'center',
          html: `<p>${validationError}</p><br><p>Deseja ir para a tela de cadastros para atualizar os dados do hóspede?</p>`,
          icon: 'warning',
          title: 'Dados Incompletos',
        }).then(result => {
          if (result.isConfirmed) {
            // Navegar para cadastros dependendo do tipo
            if (this.typeOfPerson === 'PF') {
              this.$router.push('/guest')
            } else {
              this.$router.push('/company')
            }
          }
        })

        return false
      }

      this.dataNotaFiscal.type_of_person = this.typeOfPerson
      this.dataNotaFiscal.no_show = this.noShow
      this.setDataNotaFiscal(this.dataNotaFiscal)
      this.sendSale()
      this.dialogDataNotaFiscal = false
    },

    collectResponsiblesForInvoice() {
      const responsiblesMap = new Map()

      const pushResponsible = rawResponsible => {
        if (!rawResponsible) return
        const resolved = this.resolveResponsibleData(rawResponsible)
        if (!resolved) return

        const origin = (resolved.origin || rawResponsible.origin || '').toLowerCase() || 'guest'
        let identifier = resolved.id || rawResponsible.id || ''

        if (!identifier) {
          identifier = resolved.cpf_cnpj || resolved.cnpj || resolved.cpf || resolved.email || resolved.name || Math.random().toString(36).substring(2)
        }

        const key = `${origin}_${identifier}`
        if (!responsiblesMap.has(key)) {
          responsiblesMap.set(key, { ...resolved, origin })
        }
      }

      this.getItemsCheckout.forEach(item => {
        if (item.responsible) {
          pushResponsible(item.responsible)
        }
      })

      // Garantir pelo menos um responsável padrão quando nada foi marcado
      if (responsiblesMap.size === 0 && this.getRoom && this.getRoom.current_accommodation) {
        const accommodation = this.getRoom.current_accommodation
        if (accommodation.company) {
          pushResponsible({ ...accommodation.company, origin: 'company' })
        } else if (Array.isArray(accommodation.guest)) {
          accommodation.guest.forEach(guest => pushResponsible({ ...guest, origin: 'guest' }))
        }
      }

      return Array.from(responsiblesMap.values())
    },

    resolveResponsibleData(responsible) {
      if (!responsible) return null

      if (responsible.cleaned) {
        return responsible
      }

      const origin = (responsible.origin || '').toLowerCase()
      const accommodation = this.getRoom?.current_accommodation

      if (origin === 'company') {
        if (responsible.is_custom) {
          return { ...responsible, origin: 'company', cleaned: true }
        }

        if (accommodation?.company && accommodation.company.id === responsible.id) {
          return { ...accommodation.company, origin: 'company', cleaned: true }
        }

        return { ...responsible, origin: 'company', cleaned: true }
      }

      if (origin === 'guest') {
        if (responsible.is_custom) {
          return { ...responsible, origin: 'guest', cleaned: true }
        }

        if (Array.isArray(accommodation?.guest)) {
          const guest = accommodation.guest.find(item => item.id === responsible.id)
          if (guest) {
            return { ...guest, origin: 'guest', cleaned: true }
          }
        }

        return { ...responsible, origin: 'guest', cleaned: true }
      }

      return { ...responsible, origin: origin || 'guest', cleaned: true }
    },

    normalizeResponsibleForInvoice(responsible) {
      const extractName = value => {
        if (!value) return ''
        if (typeof value === 'string') return value
        if (value.name) return value.name
        if (value.description) return value.description

        return ''
      }

      const typeOfPerson = responsible.origin === 'company' ? 'PJ' : 'PF'

      return {
        type_of_person: typeOfPerson,
        foreigner: Boolean(responsible.foreigner),
        name: responsible.fantasy_name || responsible.name || responsible.social_name || 'Responsável',
        cpf: responsible.cpf || '',
        cpf_cnpj: responsible.cpf_cnpj || responsible.cnpj || responsible.document || '',
        address: responsible.address || responsible.street || '',
        number: responsible.number || responsible.address_number || responsible.street_number || '',
        neighborhood: responsible.neighborhood || responsible.district || '',
        zipcode: responsible.zipcode || responsible.cep || responsible.zip_code || responsible.postal_code || '',
        email: responsible.email || '',
        commercial_phone: responsible.commercial_phone || responsible.phone || responsible.telephone || '',
        cell_phone: responsible.cell_phone || responsible.mobile || responsible.phone_mobile || '',
        city: extractName(responsible.city) || responsible.city_name || responsible.cidade || responsible.city_text || '',
        state: extractName(responsible.state) || responsible.state_name || responsible.estado || responsible.state_text || '',
        country: extractName(responsible.country) || responsible.country_name || responsible.pais || responsible.country_text || '',
        city_id: responsible.city_id || responsible.cidade_id || (responsible.city && responsible.city.id) || '',
        state_id: responsible.state_id || responsible.estado_id || (responsible.state && responsible.state.id) || '',
        country_id: responsible.country_id || responsible.pais_id || (responsible.country && responsible.country.id) || '',
      }
    },

    validateResponsibleForInvoice(responsible) {
      const data = this.normalizeResponsibleForInvoice(responsible)
      const missingFields = []

      if (data.type_of_person === 'PF' && !data.foreigner) {
        const cpfValue = (data.cpf || data.cpf_cnpj || '').replace(/[^\d]/g, '')
        if (cpfValue.length !== 11) {
          missingFields.push('CPF')
        } else if (!this.isValidCPF(data.cpf || data.cpf_cnpj || '')) {
          missingFields.push('CPF válido')
        }
      } else if (data.type_of_person === 'PJ') {
        const cnpjValue = (data.cpf_cnpj || '').replace(/[^\d]/g, '')
        if (cnpjValue.length !== 14) {
          missingFields.push('CNPJ')
        }
      }

      if (!data.address || data.address.trim() === '') {
        missingFields.push('Endereço')
      }
      if (!data.number || data.number.toString().trim() === '') {
        missingFields.push('Número')
      }
      if (!data.neighborhood || data.neighborhood.trim() === '') {
        missingFields.push('Bairro')
      }
      if ((data.zipcode || '').replace(/[^\d]/g, '').length !== 8) {
        missingFields.push('CEP')
      }
      if ((!data.city || data.city.trim() === '') && !data.city_id) {
        missingFields.push('Cidade')
      }
      if ((!data.state || data.state.trim() === '') && !data.state_id) {
        missingFields.push('Estado')
      }
      if (!data.email || !data.email.includes('@')) {
        missingFields.push('Email')
      }
      const hasCommercialPhone = data.commercial_phone && data.commercial_phone.replace(/[^\d]/g, '').length >= 10
      const hasCellPhone = data.cell_phone && data.cell_phone.replace(/[^\d]/g, '').length >= 10
      if (!hasCommercialPhone && !hasCellPhone) {
        missingFields.push('Telefone de contato')
      }

      if (missingFields.length > 0) {
        return {
          name: data.name,
          type: data.type_of_person,
          message: `Os seguintes dados são obrigatórios para emissão da nota fiscal: ${missingFields.join(', ')}`,
        }
      }

      return null
    },

    applyNotaFiscalFromResponsible(responsibleData, typeOfPerson) {
      const normalized = this.normalizeResponsibleForInvoice({
        ...responsibleData,
        origin: typeOfPerson === 'PF' ? 'guest' : 'company',
      })

      const toLocationObject = (value, fallbackName, fallbackId) => {
        if (!value && !fallbackName) {
          return null
        }

        if (typeof value === 'string') {
          return { id: fallbackId || null, name: value }
        }

        if (value && typeof value === 'object') {
          return {
            id: value.id || fallbackId || null,
            name: value.name || value.description || fallbackName || '',
          }
        }

        return {
          id: fallbackId || null,
          name: fallbackName || '',
        }
      }

      const cityObj = toLocationObject(responsibleData.city, normalized.city, normalized.city_id)
      const stateObj = toLocationObject(responsibleData.state, normalized.state, normalized.state_id)
      const countryObj = toLocationObject(responsibleData.country, normalized.country, normalized.country_id)

      this.typeOfPerson = normalized.type_of_person

      this.dataNotaFiscal = {
        ...responsibleData,
        type_of_person: normalized.type_of_person,
        foreigner: normalized.foreigner,
        cpf: normalized.cpf,
        cpf_cnpj: normalized.cpf_cnpj,
        address: normalized.address,
        number: normalized.number,
        complement: responsibleData.complement || '',
        neighborhood: normalized.neighborhood,
        zipcode: normalized.zipcode,
        commercial_phone: normalized.commercial_phone,
        cell_phone: normalized.cell_phone,
        email: normalized.email,
        city: cityObj,
        state: stateObj,
        country: countryObj,
        city_id: normalized.city_id || (cityObj && cityObj.id) || '',
        state_id: normalized.state_id || (stateObj && stateObj.id) || '',
        country_id: normalized.country_id || (countryObj && countryObj.id) || '',
        no_show: this.noShow,
      }

      this.cityNotaFiscal = cityObj?.name || ''
      this.stateNotaFiscal = stateObj?.name || ''
      this.countryNotaFiscal = countryObj?.name || ''

      this.setDataNotaFiscal(this.dataNotaFiscal)
    },
    toggleSelectAll(type, value) {
      const shouldCheck = Boolean(value)
      const items = type === 'daily' ? this.selectableDailyItems : this.selectableProductItems

      items.forEach(item => {
        if (item.checked !== shouldCheck) {
          this.$set(item, 'checked', shouldCheck)
          this.addItemResponsible(item)
        }
      })
    },

    validateDataForInvoice() {
      const data = this.dataNotaFiscal
      const missingFields = []

      if (this.typeOfPerson === 'PF' && !data.foreigner) {
        // Validação para Pessoa Física
        if (!data.cpf || data.cpf.replace(/[^\d]/g, '').length !== 11) {
          missingFields.push('CPF')
        } else if (!this.isValidCPF(data.cpf)) {
          missingFields.push('CPF válido')
        }
      } else if (this.typeOfPerson === 'PJ') {
        // Validação para Pessoa Jurídica
        if (!data.cpf_cnpj || data.cpf_cnpj.replace(/[^\d]/g, '').length !== 14) {
          missingFields.push('CNPJ')
        }
      }

      // Validações comuns para ambos os tipos
      if (!data.address || data.address.trim() === '') {
        missingFields.push('Endereço')
      }
      if (!data.number || data.number.trim() === '') {
        missingFields.push('Número')
      }
      if (!data.neighborhood || data.neighborhood.trim() === '') {
        missingFields.push('Bairro')
      }
      if (!data.zipcode || data.zipcode.replace(/[^\d]/g, '').length !== 8) {
        missingFields.push('CEP')
      }
      if (!this.cityNotaFiscal || this.cityNotaFiscal.trim() === '') {
        missingFields.push('Cidade')
      }
      if (!this.stateNotaFiscal || this.stateNotaFiscal.trim() === '') {
        missingFields.push('Estado')
      }
      if (!data.email || !data.email.includes('@')) {
        missingFields.push('Email')
      }
      if ((!data.commercial_phone || data.commercial_phone.trim() === '')
          && (!data.cell_phone || data.cell_phone.trim() === '')) {
        missingFields.push('Telefone de contato')
      }

      if (missingFields.length > 0) {
        return `Os seguintes dados são obrigatórios para emissão da nota fiscal: ${missingFields.join(', ')}`
      }

      return null // Dados válidos
    },

    isValidCPF(cpf) {
      // Remove caracteres não numéricos
      cpf = cpf.replace(/[^\d]/g, '')

      // Verifica se tem 11 dígitos
      if (cpf.length !== 11) return false

      // Validação do primeiro dígito verificador
      let sum = 0
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i)
      }
      let remainder = (sum * 10) % 11
      if (remainder === 10 || remainder === 11) remainder = 0
      if (remainder !== parseInt(cpf.charAt(9))) return false

      // Validação do segundo dígito verificador
      sum = 0
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i)
      }
      remainder = (sum * 10) % 11
      if (remainder === 10 || remainder === 11) remainder = 0
      if (remainder !== parseInt(cpf.charAt(10))) return false

      return true
    },

    async sendSale() {
      const hasInvoice = this.getpaymentMethods.some(p => p.method === 'invoice')
      if (hasInvoice) {
        const company = this.getRoom?.current_accommodation?.company
        if (company?.id && company?.allow_billing) {
          try {
            const response = await this.getCompanyCredit(company.id)
            const data = response?.data?.data || {}
            if (data.billing_blocked) {
              this.$swal({
                icon: 'error',
                title: 'Faturamento Bloqueado',
                html: `Faturamento bloqueado: faturas vencidas há <strong>${data.overdue_days || 0} dias</strong>${data.billing_overdue_tolerance != null ? ` (tolerância: ${data.billing_overdue_tolerance} dias)` : ''}.`,
                confirmButtonColor: '#FF4C51',
              })

              return
            }
          } catch (e) { /* deixa o backend rejeitar */ }
        }
      }

      this.loadingCheckout = true
      this.storeSale()
        .then(response => {
          this.$toast.success('Checkout realizado com sucesso!')
          this.downloadPdfCheckout()
        })
        .catch(() => {
          this.loadingCheckout = false
        })
    },
    async openGroupTransfer() {
      this.loadingGroupTransfer = true

      try {
        const response = await this.getGroupAccount(this.groupReserveId)
        const account = response.data?.account?.account
        if (!account?.id) {
          this.$toast.error('Abra a conta master do grupo antes de transferir este quarto.')

          return
        }
        if (account.status !== 'open') {
          this.$toast.error('A conta master do grupo não está aberta para receber quartos.')

          return
        }

        this.groupTransferAccount = account
        this.groupCoverageMode = account.coverage_mode || 'lodging'
        this.groupTransferPayments = await this.getPartialPayment()
          .then(payments => payments.data || [])
          .catch(() => [])
        this.groupTransferDialog = true
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Não foi possível abrir a conta master do grupo.')
      } finally {
        this.loadingGroupTransfer = false
      }
    },
    async transferToGroupAccount(selection) {
      this.loadingGroupTransfer = true

      try {
        await this.$store.dispatch('checkout/transferToGroupAccount', {
          groupAccountId: this.groupTransferAccount.id,
          ...selection,
        })
        this.groupTransferDialog = false
        this.$toast.success('Quarto enviado para a conta master.')
        this.$router.push({ name: 'group_account', params: { group_id: this.groupReserveId } })
      } catch (error) {
        const data = error.response?.data
        const message = (typeof data === 'string' ? data : data?.message) || 'Não foi possível transferir o checkout para a conta master.'
        this.$toast.error(message)
      } finally {
        this.loadingGroupTransfer = false
      }
    },
    partialPayment() { },
    downloadPdfCheckout() {
      this.$toast.info('Aguarde... , Gerando arquivo de checkout!', {
        duration: 0,
      })
      this.exportPdfCheckout()
        .then(response => {
          // mostra pdf
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'checkout.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
          this.$toast.error('Não foi possível gerar arquivo de checkout')
        })
        .finally(() => {
          this.clearCheckout()
          this.$router.push('/manager_room')
          this.loadingCheckout = false
        })
    },

    formatMoney(value) {
      if (value != null) {
        return value.toLocaleString('PT-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },

    // Autorização

    loadCurrentRole() {
      this.getUser().then(response => {
        if (response.data.role.name == 'Admin') {
          this.admRole.authorization = true
        } else {
          this.admRole.authorization = false
        }
      })
    },

    validEmail() {
      if (this.admLogin.email === '') {
        this.message_error_email = 'Obrigatório'

        return false
      }
      this.message_error_email = ''

      return true
    },
    validPassword() {
      if (this.admLogin.password === '') {
        this.message_error_password = 'Obrigatório'

        return false
      }
      this.message_error_password = ''

      return true
    },

    queueAuthorization(type, payload = null) {
      this.pendingAuthorization = { type, payload }
      this.dialogAuthorization = true
    },
    requestAuthorization() {
      if (!this.validEmail() || !this.validPassword()) return

      const pending = this.pendingAuthorization

      if (!pending) {
        this.$toast.error('Nenhuma ação pendente para autorização')

        return
      }

      const credentials = {
        email: this.admLogin.email,
        password: this.admLogin.password,
      }

      // Não valida role - qualquer usuário com a permissão específica pode autorizar
      const validate = loginData => true

      // Executa a ação conforme o tipo
      const request = token => {
        switch (pending.type) {
          case 'remove_payment_partial':
            return this.performRemovePaymentPartial(pending.payload, token)
          default:
            return Promise.resolve()
        }
      }

      this.authorizationProcessing = true

      this.runAuthorization({ credentials, validate, request })
        .then(() => {
          this.admRole.authorization = true
          this.dialogAuthorization = false
          this.pendingAuthorization = null
          this.$toast.success('Usuário autorizado')
        })
        .catch(error => {
          const message = error?.response?.data?.message
                         || error?.message
                         || 'Usuário não autorizado'
          this.$toast.error(message)
        })
        .finally(() => {
          this.authorizationProcessing = false
          this.admLogin.email = ''
          this.admLogin.password = ''
          this.message_error_email = ''
          this.message_error_password = ''
        })
    },
    cancelAuthorization() {
      this.dialogAuthorization = false
      this.pendingAuthorization = null
      this.admLogin.email = ''
      this.admLogin.password = ''
      this.message_error_email = ''
      this.message_error_password = ''
      this.authorizationProcessing = false

      // Para o loading do dialog de justificativa
      this.loadingRemovePaymentPartial = false
    },
    showDialogObservations() {
      const accommodation_id = this.getRoom.current_accommodation.id
      this.getAccommodationObservations(accommodation_id).then(response => {
        this.accommodation_observations = response.data
      })
      this.dialogObservation = true
    },
  },
}
</script>

<style scoped>
.troco {
  color: #ff4c51;
}

.text_total {
  color: black;
  font-size: 16px;
}

.pay {
  color: black;
}

.select_customer {
  cursor: pointer;
}

.select_customer:hover {
  background: #fafafa;
}

.box_car_empty {
  margin-top: 80%;
}

.select-all-row .select-all-label {
  font-size: 14px;
  color: #424242;
  margin-left: 8px;
}

.item_checkout {
  height: 50px;
  cursor: pointer;
}

.item_checkout:hover {
  background: #fafafa;
}

.empty {
  height: 350px;
  width: 100%;
}
</style>
